export const intlZhCn = {
    测试: '测试',
    登录: '登录',
    注册: '注册',
    变量的例子: '变量的例子 {value}',
    多样式多语言例子:
        '<span style="font-size: 10px;color: #d7cab3;">Your team total bet 199999, you can get <span style="font-size: 14px;color: #fff;font-weight: 600;">@money</span> per monthly</span>',
    体育: '体育',
    存款: '存款',
    提款: '提款',
    请登录: '请登录',
    余额刷新成功: '余额刷新成功',
    我的金额: '我的金额',
    我的邀请码: '我的邀请码',
    复制成功: '复制成功',
    下一次抽奖: '下一次抽奖',
    您没有抽奖的机会: '您没有抽奖的机会',
    规则: '规则',
    我的: '我的',
    我的信息: '我的信息',
    资金详情: '资金详情',
    在线客服: '在线客服',
    客服暂未配置: '客服暂未配置',
    促销码: '促销码',
    请输入促销码: '请输入促销码',
    验证码: '验证码',
    请输入验证码: '请输入验证码',
    提交: '提交',
    退出登录: '退出登录',
    提示: '提示',
    '确定要退出登录吗？': '确定要退出登录吗？',
    取消: '取消',
    确定: '确定',
    '升级到 {value} 还需要 {value}': '升级到 {value1} 还需要 {value2}',
    头像: '头像',
    用户名: '用户名',
    登录密码: '登录密码',
    提现密码: '提现密码',
    修改提现密码: '修改提现密码',
    修改密码: '修改密码',
    设置提现密码: '设置提现密码',
    请输入提现密码: '请输入提现密码',
    请再次输入提现密码: '请再次输入提现密码',
    提现密码不能为空: '提现密码不能为空',
    确认提现密码不能为空: '确认提现密码不能为空',
    提现密码格式不正确: '提现密码格式不正确',
    确认提现密码格式不正确: '确认提现密码格式不正确',
    提现密码和确认提现密码不一致: '提现密码和确认提现密码不一致',
    设置提现密码成功: '设置提现密码成功',
    请输入旧密码: '请输入旧密码',
    请输入新密码: '请输入新密码',
    请再次输入新密码: '请再次输入新密码',
    旧密码不能为空: '旧密码不能为空',
    新密码不能为空: '新密码不能为空',
    确认密码不能为空: '确认密码不能为空',
    '旧密码格式不正确, 请输入6-18位字母或数字': '旧密码格式不正确, 请输入6-18位字母或数字',
    '新密码格式不正确, 请输入6-18位字母或数字': '新密码格式不正确, 请输入6-18位字母或数字',
    '确认密码格式不正确, 请输入6-18位字母或数字': '确认密码格式不正确, 请输入6-18位字母或数字',
    新密码和确认密码不一致: '新密码和确认密码不一致',
    '修改密码成功, 请重新登录': '修改密码成功, 请重新登录',
    修改提现密码成功: '修改提现密码成功',
    选择头像: '选择头像',
    今天: '今天',
    昨天: '昨天',
    一个月内: '一个月内',
    余额: '余额',
    编号: '编号',
    备注: '备注',
    提现金额: '提现金额',
    充值: '充值',
    账变: '账变',
    所有类型: '所有类型',
    每天: '每天',
    每周: '每周',
    每月: '每月',
    活动名称: '活动名称',
    优惠金额: '优惠金额',
    申请时间: '申请时间',
    '发放/审核时间': '发放/审核时间',
    状态: '状态',
    活动奖项: '活动奖项',
    排名: '排名',
    每日列表: '每日列表',
    每周列表: '每周列表',
    每月列表: '每月列表',
    没有排名: '没有排名',
    我的投注: '我的投注',
    我的奖励: '我的奖励',
    剩余排名: '剩余排名',
    空缺: '空缺',
    奖励: '奖励',
    总投注: '总投注',
    投注: '投注',
    '占所有玩家总投注额的 {value} %': '占所有玩家总投注额的 {value} %',
    暂无数据: '暂无数据',
    首页: '首页',
    优惠活动: '优惠活动',
    推广: '推广',
    请选择: '请选择',
    年: '年',
    月: '月',
    日: '日',
    上午: '上午',
    下午: '下午',
    天: '天',
    周: '周',
    投注返利详情: '<span style="font-size: 10px;color: #d7cab3;">您的团队总投注金额为 {value1}, 您每月最多可获得 <span style="font-size: 14px;color: #fff;font-weight: 600;">{value2}</span></span>',
    优惠活动详情: '优惠活动详情',
    活动申请: '活动申请',
    加载中: '加载中',
    申请: '申请',
    申请成功: '申请成功',
    申请失败: '申请失败',
    所有记录: '所有记录',
    申请中: '申请中',
    发放成功: '发放成功',
    审核失败: '审核失败',
    活动申请记录: '活动申请记录',
    原因: '原因',
    邮件: '邮件',
    邮件最多可保存30天: '邮件最多可保存 30 天',
    删除已读: '删除已读',
    全部接收: '全部接收',
    邮件详情: '邮件详情',
    删除: '删除',
    确认密码: '确认密码',
    真实姓名: '真实姓名',
    姓: '姓',
    名: '名',
    邮箱: '邮箱',
    邮箱验证码: '邮箱验证码',
    发送: '发送',
    手机号: '手机号',
    手机验证码: '手机验证码',
    出生日期: '出生日期',
    twitter: 'twitter',
    facebook: 'facebook',
    证件类型: '证件类型',
    证件号: '证件号',
    推广码: '推广码',
    优惠码: '优惠码',
    登录成功: '登录成功',
    登录失败: '登录失败',
    登录账号: '登录账号',
    请输入正确的邮箱: '请输入正确的邮箱',
    请选择手机区号: '请选择手机区号',
    手机号校验: '请输入6~12位手机号',
    请输入10位手机号: '请输入10位手机号',
    验证码发送成功: '验证码发送成功',
    用户名验证: '用户名必须以(6~15位)字母开头的小写字母和数字组合',
    用户名不能以test为起始: '用户名不能以test为起始',
    密码必须为6位数字: '密码必须为6位数字',
    确认密码必须为6位数字: '确认密码必须为6位数字',
    两次输入的密码不一致: '两次输入的密码不一致',
    登录密码验证: '密码必须为(6~18位)字母、数字或特殊字符组合',
    确认登录密码验证: '确认密码必须为(6~18位)字母、数字或特殊字符组合',
    请输入正确的姓名: '请输入正确的姓名',
    请输入出生日期: '请输入出生日期',
    请输入您的twitter账号: '请输入您的{value}账号',
    请输入您的facebook账号: '请输入您的facebook账号',
    推广码校验: '确认输入正确的推广码(1~8位数字)',
    推广码校验2: '请输入推广码',
    请点击开始验证: '请点击开始验证',
    请输入邮箱验证码: '请输入邮箱验证码',
    请输入手机验证码: '请输入手机验证码',
    请输入姓: '请输入姓',
    请输入名: '请输入名',
    请输入证件号: '请输入证件号',
    请输入有效的CURP: '请输入有效的CURP',
    '请输入11~14位数字': '请输入11~14位数字',
    请选择证件类型: '请选择证件类型',
    请接受服务条款: '请接受服务条款',
    邀请奖励: '邀请奖励',
    问题1: 'Q1：佣金分成是什么意思？',
    回答1: 'A1：邀请好友加入应用并绑定您的邀请码后，您将根据这些好友的消费金额，按照一定比例获得额外佣金。',
    问题2: 'Q2：俱乐部是什么意思？',
    回答2: 'A2：您的俱乐部由您所有的代理团队成员组成。',
    问题3: 'Q3：如何升级到更高的俱乐部星级？',
    回答3: 'A3：您可以通过邀请更多好友或与团队成员集体消费来升级，更详细信息请参考升级要求表。',
    问题4: 'Q4：如何获得奖励？',
    回答4: 'A4：一旦您的好友或好友邀请人进行消费，您将立即获得所有奖励，奖励将存入您的佣金账户，次日即可提现到您的钱包。',
    问题5: 'Q5：提现奖励有下注要求吗？',
    回答5: 'A5：有一次性下注要求。',
    问题6: 'Q6：我什么时候可以使用我的奖励？',
    回答6: 'A6：您可以将奖励提现到您的钱包，用于下次消费天，有时可能会有轻微延迟，谢谢您的理解。',
    佣金比例详情: '※您可以从A、B、C三人的所有投注金额中获得一定比例的佣金，具体佣金率请参考下图。',
    返利比例详情: '※不同游戏的返佣比例不同，您也可以通过提升俱乐部星级来提高返佣比例。',
    立即邀请: '立即邀请！',
    佣金率: '佣金率',
    流水返利: '按流水返佣',
    俱乐部之星: '俱乐部星级',
    佣金等级: 'Lv{value} 佣金',
    首存返利: '首存返佣',
    什么是俱乐部: '什么是俱乐部？',
    俱乐部的星级越高介绍: '您和您所有的代理商组成您的俱乐部。俱乐部星级越高，返利比例越高。',
    你的俱乐部: '你的俱乐部',
    如何提高俱乐部的星级: '如何提高俱乐部星级？',
    代理要求: '经纪人要求',
    投注要求: '投注要求',
    无星: '无星',
    一星: '一星',
    二星: '二星',
    三星: '三星',
    全部: '全部',
    我的奖金: '我的奖金',
    下一级: '下一级',
    累计存款: '累积存款{deposit}',
    每日提款限额: '每日提现限额',
    每日提现次数: '每日提现次数',
    每月累计存款升级VIP等级: '每月累计存款升级VIP等级',
    等级: '等级',
    月度奖金: '每月奖金',
    等级升级奖励: '等级升级奖金',
    现金奖励发放时间: '现金奖金：根据您本月末的VIP等级，此奖励将于下个月1日上午10点发送给您。',
    晋级彩金: '升级奖金',
    每月奖金: '每月奖金',
    投注返水: '投注返利',
    网络问题: '网络问题',
    '检测到您目前没有网络连接，请开启网络后再试。': '检测到您目前没有网络连接，请开启网络后再试。',
    设置: '设置',
    总奖励: '总奖励',
    邀请总数: '邀请总数',
    邀请有效用户数量: '您共邀请了{value1}位好友，其中{value2}位为有效用户。',
    邀请新客户获得: '邀请新客户获得',
    邀请好友可获得: '邀请好友可获得',
    邀请好友获取金钱: '邀请好友可得奖励',
    每日邀请次数: '每日邀请次数：{value}',
    邀请300位好友可获得: '邀请{value}位好友获得',
    如何参与: '如何参与',
    步骤1: '步骤1：注册',
    步骤2: '步骤2：点击任意邀请页面邀请好友',
    步骤3: '步骤3：好友注册并输入邀请码',
    步骤4: '步骤4：好友充值{value}',
    步骤5: '步骤5：领取奖励',
    什么是有效邀请用户: '什么是有效邀请用户？',
    有效邀请用户描述: '有效邀请用户是指累计充值金额大于{value}的用户',
    奖励兑换: '奖励兑现',
    奖励兑换步骤1: '每邀请成功一次，邀请人可获得{value1}。',
    奖励兑换步骤2: '直接代理（邀请人的上级）可获得{value}奖励。',
    奖励兑换步骤3: '直接代理的上级代理可获得{value}奖励。',
    奖励兑换步骤4: '被邀请用户也可获得{value}奖励。',
    奖励兑换步骤5: '奖励可用于玩游戏。',
    奖励兑换步骤6: '奖励由系统自动发放。',
    活动解释权: '{value}保留此活动的最终解释权。',
    '安装权限未被授予，无法打开APK文件': '安装权限未被授予，无法打开APK文件',
    '权限已授予，正在尝试打开APK...': '权限已授予，正在尝试打开APK...',
    立即更新: '立即更新',
    稍后更新: '稍后更新',
    版本号不符合规范: '版本号不符合规范',
    邀请人数: '邀请人数',
    奖励详情: '奖励详情',
    '网络错误, 请稍后重试!': '网络错误, 请稍后重试!',
    存款金额: '存款金额',
    奖励金额: '奖励金额',
    立即存款: '立即存款',
    今天不再显示: '今天不再显示',
    倒计时: '倒计时',
    应用未安装: '应用未安装',
    邀请码: '邀请码',
    请输入用户名: '请输入用户名',
    密码: '密码',
    请输入密码: '请输入密码',
    '密码必须为(6~18位)字母或数字组合': '密码必须为(6~18位)字母或数字组合',
    忘记密码: '忘记密码',
    注册账号: '注册账号',
    重置密码: '重置密码',
    '确定进入游戏吗?': '确定进入游戏吗?',
    进入游戏失败: '进入游戏失败',
    '确定要支付吗?': '确定要支付吗?',
    充值请求已取消: '充值请求已取消',
    已提交充值请求: '已提交充值请求',
    存款方式: '存款方式',
    存款账户: '存款账户',
    收款户名: '收款户名: ',
    银行账户: '银行账户: ',
    开户地址: '开户地址: ',
    开户银行: '开户银行: ',
    单笔范围: '单笔范围: ',
    存款优惠: '存款优惠',
    最高奖金: '最高奖金: ',
    剩余数量: '剩余数量: ',
    不选择: '不选择',
    请选择优惠: '请选择优惠',
    充值优惠详情: '充值优惠详情',
    详情: '详情',
    最小额: '最小额',
    最大额: '最大额',
    存款提示: '存款提示',
    存款提示1: '每笔存款将在1-5分钟内到账',
    存款提示2: '您可以随时联系客服解决押金问题',
    充值金额不能小于最小金额: '充值金额不能小于最小金额',
    立即支付: '立即支付',
    下一步: '下一步',
    USDT数量: 'USDT数量',
    充值金额: '充值金额',
    复制: '复制',
    TXID后五位: 'TXID后五位',
    汇款信息: '汇款信息',
    '(必填)请输入汇款人姓名或者卡号后四位': '(必填)请输入汇款人姓名或者卡号后四位',
    上一步: '上一步',
    备注信息不允许为空: '备注信息不允许为空',
    收款银行: '收款银行 ',
    银行地址: '银行地址 ',
    PIX类型: 'PIX类型 ',
    账号名称: '账号名称',
    收款账户: '收款账户 ',
    PIX账号: 'PIX账号',
    选择钱包类型: '选择钱包类型',
    '获取钱包列表失败, 请联系客服': '获取钱包列表失败, 请联系客服',
    请选择钱包类型: '请选择钱包类型',
    收款地址: '收款地址 ',
    当前汇率: '当前汇率',
    转换金额: '转换金额 ',
    单日提现金额上限: '单日提现金额上限: ',
    单日提现次数上限: '单日提现次数上限: ',
    单笔最低提现额度: '单笔最低提现额度: ',
    单笔最高提现额度: '单笔最高提现额度: ',
    提现时间段: '提现时间段: ',
    普通余额: '普通余额: ',
    代理余额: '代理余额: ',
    普通余额可兑换USDT数量: '普通余额可兑换USDT数量: ',
    代理余额可兑换USDT数量: '代理余额可兑换USDT数量: ',
    '你还没绑定三方钱包哦!': '你还没绑定三方钱包哦!',
    选择钱包: '选择钱包',
    请输入提现金额: '请输入提现金额',
    请输入有效金额: '请输入有效金额',
    请输入正整数金额: '请输入正整数金额',
    普通余额不足: '普通余额不足',
    代理余额不足: '代理余额不足',
    请选择三方钱包: '请选择三方钱包',
    '你还没虚拟货币地址哦!': '你还没虚拟货币地址哦!',
    请输入要兑换的USDT数量: '请输入要兑换的USDT数量',
    请输入有效枚数: '请输入有效枚数',
    请输入正整数枚数: '请输入正整数枚数',
    提款数量不能大于可提款USDT数量: '提款数量不能大于可提款USDT数量',
    请输入提款金额: '请输入提款金额',
    请选择钱包: '请选择钱包',
    '你还没绑定银行卡哦!': '你还没绑定银行卡哦!',
    选择银行卡: '选择银行卡',
    请选择银行卡: '请选择银行卡',
    '你还没绑定PIX哦!': '你还没绑定PIX哦!',
    选择PIX: '选择PIX',
    请选择PIX类型: '请选择PIX类型',
    '你还没绑定支付宝哦!': '你还没绑定支付宝哦!',
    选择支付宝: '选择支付宝',
    请选择支付宝: '请选择支付宝',
    去绑定: '去绑定',
    已选: '已选',
    兑换全部: '兑换全部',
    当前提款不在时间段内: '当前提款不在时间段内',
    钱包中心: '钱包中心',
    绑卡提示: '尊敬的用户,为了您的信息安全,默认只能绑定{value}张卡,如需排除或修改,请联系客服',
    钱包地址: '钱包地址',
    请输入钱包地址: '请输入钱包地址',
    请输入字母或数字: '请输入字母或数字',
    钱包姓名: '钱包姓名',
    请输入钱包姓名: '请输入钱包姓名',
    持卡人姓名: '持卡人姓名',
    钱包名称: '钱包名称',
    钱包账号: '钱包账号',
    开户行地址: '开户行地址',
    钱包类型: '钱包类型',
    "TRC20需以字母'T'开头的34位字符": "TRC20需以字母'T'开头的34位字符",
    银行卡类型: '银行卡类型',
    请选择银行卡类型: '请选择银行卡类型',
    请输入开户行地址: '请输入开户行地址',
    已有银行卡号: '已有银行卡号',
    请输入已有银行卡号: '请输入已有银行卡号',
    银行卡账号: '银行卡账号',
    请输入银行卡账号: '请输入银行卡账号',
    请输入持卡人姓名: '请输入持卡人姓名',
    银行名称: '银行名称',
    银行账号: '银行账号',
    支付宝姓名: '支付宝姓名',
    请输入支付宝姓名: '请输入支付宝姓名',
    支付宝账号: '支付宝账号',
    请输入支付宝账号: '请输入支付宝账号',
    添加新账户: '添加新账户',
    资料信息提交成功: '资料信息提交成功',
    联系地址: '联系地址',
    请输入联系地址: '请输入联系地址',
    完善信息: '完善信息',
    请先完善个人信息: '请先完善个人信息',
    请先选择优惠: '请先选择优惠',
    请输入PIX账号: '请输入PIX账号',
    活动金额: '活动金额',
    更换成功: '更换成功',
    注册成功: '注册成功',
    注册失败: '注册失败',
    请选择线路: '请选择线路',
    '线路{value}': '线路{value}',
    存款前请先绑定银行卡: '存款前请先绑定银行卡',
    额度回收: '额度回收',
    一键刷新: '一键刷新',
    一键回收: '一键回收',
    主平台金额: '主平台金额',
    我的团队俱乐部: '我的团队俱乐部',
    俱乐部星级: '俱乐部星级',
    俱乐部星级提示: '你和你所有的经纪人组成了你的俱乐部。俱乐部的星级越高，佣金就越高。',
    俱乐部成员: '俱乐部成员',
    俱乐部投注: '俱乐部投注',
    我的返佣: '我的返佣:',
    投注返佣高达: '投注返佣高达',
    首次存款返佣: '首次存款返佣',
    可领取: '可领取',
    领取: '领取',
    领取成功: '领取成功',
    领取失败: '领取失败',
    今日奖励: '今日奖励',
    邀请朋友: '邀请朋友',
    通过WhatsApp邀请: '通过WhatsApp邀请',
    保存图片: '保存图片',
    分享: '分享',
    从属数据: '从属数据',
    总人数: '总人数',
    本月: '本月',
    层级: '层级',
    加入时间: '加入时间',
    佣金: '佣金',
    提款历史记录: '提款历史记录',
    邀请: '邀请',
    邀请任务: '邀请任务',
    时间: '时间',
    佣金金额: '佣金金额',
    成功: '成功',
    下级: '下级',
    受邀人数: '受邀人数',
    佣金总额: '佣金总额',
    提现公告: '{value1} 成功提现 {value2}',
    个人资料: '个人资料',
    用户信息: '用户信息',
    昵称: '用户名',
    今天1: '今天',
    昨天1: '昨天',
    奖励详情1: '奖励详情',
    投注1: '投注',
    存款1: '存款',
    状态1: '状态',
    邀请奖励高达: '邀请奖励高达',
    平台名称: '平台名称',
    金额: '金额',
    刷新: '刷新',
    回收: '回收',
    休眠提示: '点击过于频繁,请{value}秒后尝试',
    刷新成功: '刷新成功',
    刷新失败: '刷新失败',
    回收成功: '回收成功',
    回收失败: '回收失败',
    存款提示3: '1.每笔存款将在1-5分钟内到账。',
    存款提示4: '2.您可以随时联系客服解决存款问题。',
    提款提示: '提款提示',
    提款提示1: '正常情况下，提现金额将在2小时左右到达您的账户，最长不会超过24小时',
    钱包: '钱包',
    我的余额: '我的余额',
    绑定手机号: '绑定手机号',
    绑定成功: '绑定成功',
    未绑定: '未绑定',
    验证码发送失败: '验证码发送失败',
    投注记录: '投注记录',
    投注金额: '投注金额',
    投注时间: '投注时间',
    订单号: '订单号',
    平台: '平台',
    游戏名: '游戏名',
    玩法: '玩法',
    投注模式: '投注模式',
    有效投注: '有效投注',
    盈亏金额: '盈亏金额',
    '1、功能优化、性能优化': '1、功能优化、性能优化',
    '2、修复一些已知问题': '2、修复一些已知问题',
    发现新版本: '发现新版本',
    奖励2: '奖励',
    下一次免费旋转: '下一次免费旋转',
    请输入正确的IFSC码: '请输入正确的IFSC码',
    记录: '记录',
    提款剩余时间: '提款剩余时间 ',
    收集提现: '当您收集到 {value} 时即可提款',
    剩余提现额: '<span style="font-size: 13px;color: #ffffff;">仅需 <span style="font-size: 13px;color: #e9b742;">{value}</span> 即可</span>',
    邀请好友获得免费旋转: '邀请朋友获得免费旋转',
    选择您的奖励: '选择您的奖励',
    每日免费提款: '每日免费提款',
    所有时间: '所有时间',
    本周: '本周',
    上周: '上周',
    QQ: 'QQ',
    微信: '微信',
    telegram: 'telegram',
    whatsApp: 'whatsApp',
    line: 'line',
    instagram: 'Instagram',
    手机号格式不正确: '手机号格式不正确',
    请输入真实姓名: '请输入真实姓名',
    不限制: '不限制',
    请输入订单号: '请输入订单号',
    立即游戏: '立即游戏',
    '存款 {value} 即可获得 {value} 次旋转。': '存款 {value1} 即可获得 {value2} 次旋转。',
    '1次': '{value} 次',
    历史: '历史',
    活动规则: '活动规则',
    游戏维护中: '游戏维护中',
    游戏维护时间: '游戏维护中,维护时间: {value}',
    快捷登录: '快捷登录',
    绑定Google账号: '绑定Google账号',
    绑定失败: '绑定失败',
    支持: '支持',
    更多: '更多',
    提现次数: '{value} 次',
    '请安装Google Play服务': '请安装Google Play服务',
    '暂无相册权限，请前往设置开启权限': '暂无相册权限，请前往设置开启权限',
    '暂无相机权限，请前往设置开启权限': '暂无相机权限，请前往设置开启权限',
    '暂无麦克风权限，请前往设置开启权限': '暂无麦克风权限，请前往设置开启权限',
    '暂无手机存储权限，请前往设置开启权限': '暂无手机存储权限，请前往设置开启权限',
    请输入IFSC码: '请输入IFSC码',
    搜索: '搜索',
    恭喜你: '恭喜你',
    用户名或手机号码: '用户名或手机号码',
    请输入用户名或手机号码: '请输入用户名或手机号码',
    玩法说明: '玩法说明',
    截止时间: '截止时间',
    随机投注: '随机投注',
    游戏记录: '游戏记录',
    图表趋势: '图表趋势',
    我的投注记录: '我的投注记录',
    期号: '期号',
    '大/小': '大/小',
    数字: '数字',
    颜色: '颜色',
    大: '大',
    小: '小',
    '投注助手（过去100期）': '投注助手（过去100期）',
    开奖号码: '开奖号码',
    数量: '数量',
    我同意: '我同意',
    预售规则详情:
        '为保障参与预售用户的合法权益，维护正常的运营秩序，规则按照相关协议和规定执行。 1.1 预售定义：指商家提供产品或服务方案，通过产品预售工具收集消费者订单，按照事先约定向消费者提供商品或服务的销售模式。 1.2 预售-销售模式是一种"存款"模式。 "定金"是指预先交割的商品预售价款中的固定金额。 "存款"可参与小游戏，有机会赢取更多存款。 存款可以直接兑换商品。 1.3 预售商品：指商户使用预售商品工具发布的商品。 仅在商品标题或商品详情页标注预售字样，未使用商品预售工具的商品不属于预售商品 1.4 预售系统：指为支持商家进行预售而提供的系统商品工具-sale model sales. 1.5 预售商品价格：指预售商品的销售价格。 预售商品的价格由定金和尾款两部分组成。',
    预售规则: '预售规则',
    总金额: '总金额',
    投注金额必须大于0: '投注金额必须大于0',
    请同意预售规则: '请同意预售规则',
    投注小于最小限额: '投注小于最小限额',
    投注大于最大限额: '投注大于最大限额',
    当前期已封盘: '当前期已封盘',
    请选择投注内容: '请选择投注内容',
    投注失败: '投注失败',
    投注成功: '投注成功',
    红色: '红色',
    绿色: '绿色',
    紫色: '紫色',
    购买金额: '购买金额',
    购买数量: '购买数量',
    税后金额: '税后金额',
    税收: '税收',
    结果: '结果',
    选择: '选择',
    '输/赢': '输/赢',
    创建时间: '创建时间',
    'WIN GO彩票': 'WIN GO彩票',
    'WIN GO规则详情':
        '如果您花费100进行交易，扣除2个服务费后，您的合约价值为98：<br/><br/>1. 选择绿色：如果结果显示1,3,7,9，您将得到(98*2) 196；如果结果显示5，您将得到(98*1.5) 147<br/><br/>2. 选择红色：如果结果显示2,4,6,8，则得到(98*2) 196；如果结果显示0，则得到(98*1.5) 147<br/><br/>3. 选择紫色：如果结果显示0或5，您将收到(98*4.5) 441<br/><br/>4. 选择号码：如果结果与所选号码相同，您将收到（98*9）882<br/>5. 选择大：如果结果显示5,6,7,8,9，您将得到(98*2) 196<br/><br/>6. 选择小：如果结果显示0,1,2,3,4，您将得到(98 * 2) 196',
    该玩法不允许下注: '该玩法不允许下注',
    总赌注: '总赌注',
    赔率: '赔率',
    选择3个唯一号码: '选择3个唯一号码',
    '*如果开盘号码与3个投注号码匹配，则中奖。': '*如果开盘号码与3个投注号码匹配，则中奖。',
    '*如果开奖号码是相同号码中的任意三个，则中奖。': '*如果开奖号码是相同号码中的任意三个，则中奖。',
    '*如果开盘号码与2个投注号码匹配，则中奖。（三个相同的数字除外）。': '*如果开盘号码与2个投注号码匹配，则中奖。（三个相同的数字除外）。',
    选择2个相同的数字: '选择2个相同的数字',
    选择一对独特的数字: '选择一对独特的数字',
    '选择至少1对相同号码和1对不同号码进行投注，如果开盘号码与投注号码相符，则中奖。': '选择至少1对相同号码和1对不同号码进行投注，如果开盘号码与投注号码相符，则中奖。',
    选择2个不同的数字: '选择2个不同的数字',
    选择3个不同的数字: '选择3个不同的数字',
    '*选择3个或更多不同的数字。所抽中的3个号码若不同且符合选择，则中奖': '*选择3个或更多不同的数字。所抽中的3个号码若不同且符合选择，则中奖',
    '*选择2个或更多不同的号码。 如果抽取的2个号码不同且符合选择，则中奖。': '*选择2个或更多不同的号码。 如果抽取的2个号码不同且符合选择，则中奖。',
    '*若开奖号码为三个连续号码，则中奖。': '*若开奖号码为三个连续号码，则中奖。',
    玩法提示1: '选择2个相同的数字，如果开奖结果与您选择的数字相符，您就赢了（除非3个数字相同）。',
    玩法提示2: '选择2个相同的数字和1个不同的数字，如果开奖结果与您选择的数字相符，您就赢了。',
    玩法提示3: '选择3个相同的数字，如果开奖结果与您选择的数字相符，您就赢了。',
    玩法提示4: '选择任意3个相同的数字，如果开奖结果为任意3个相同的数字，您就赢了。',
    玩法提示5: '选择3个或更多不同的数字，如果开奖结果与您选择的数字相符，您就赢了。',
    玩法提示6: '选择任意3个连续的数字，如果开奖结果为任意3个连续的数字，您就赢了。',
    玩法提示7: '选择2个或更多不同的数字，如果开奖结果为不同的数字，并且与您选择的数字相符，您就赢了。',
    K3彩票: 'K3 彩票',
    K3规则详情:
        '快速抽3个骰子，每个周期得到3个数字，骰子数字由111到666（无0）的自然数组成，骰子数字并不总是连续的，您可以猜整个骰子或部分骰子。<br/><br/>总和值<br/>猜3个骰子的数值之和<br/><br/>3个相等的数字<br/>对 3 个相同的特殊号码下注（111、222、...、666）。<br/><br/>2 个相等的数字<br/>对 2 个相同的数字下注<br/><br/>2个相同的数字+1个不同的数字<br/>对 2 个相同的号码和 1 个不同的号码下注<br/><br/>3个不同的数字<br/>对 3 个不同的数字下注<br/><br/>2个不同的数字<br/>对 2 个不同的数字下注<br/><br/>3个连续的数字<br/>对 3 个连续的数字下注<br/>（123、234、345、456）<br/><br/>小（3-11）<br/>大（12-18）',
    总和: '总和',
    '奇/偶': '奇/偶',
    '2个相同': '2个相同',
    '3个相同': '3个相同',
    '3个连续': '3个连续',
    不同数字: '不同数字',
    '5D彩票': '5D 彩票',
    '5D规则详情':
        '绘制说明<br/>每期随机抽取5位数字（00000-99999）<br/>例如：<br/>本期开奖号码为12345<br/>A=1<br/>B=2<br/>C=3<br/>D=4<br/>E=5<br/>总和=A+B+C+D+E=15<br/>怎么玩<br/>玩家可以指定六种投注结果A、B、C、D、E及其总和<br/>A、B、C、D、E均可购买<br/>数量（0 1 2 3 4 5 6 7 8 9）<br/>低（0 1 2 3 4）<br/>奇数 (1 3 5 7 9)<br/>高 (5 6 7 8 9)<br/>奇数 (1 3 5 7 9)<br/>偶数 (0 2 4 6 8)<br/>总和=A+B+C+D+E 可购买<br/>低（0-22）<br/>高（23-45）<br/>奇数 (1 3 …43 45)<br/>对 (0 2 …42 44)',
    下拉即可刷新: '下拉即可刷新',
    释放即可刷新: '释放即可刷新',
    没有更多了: '没有更多了',
    试玩提示: '您正在进入试用体验，盈利后不可提现',
    分享链接: '分享链接',
    应用已更新: '应用已更新',
    点击确定重启App生效: '点击确定重启App生效',
    热门: '热门',
    最近: '最近',
    收藏: '收藏',
    邀请好友帮忙提现: '1.邀请好友帮忙提现',
    向随机玩家发送邀请以提供帮助: '2.向随机玩家发送邀请以提供帮助',
    通过短信发送消息: '发送消息于',
    短信: '短信',
    今天剩余提款额度: '今天剩余提款额度',
    VIP每日限额: 'VIP每日限额',
    今天剩余提款次数: '今天剩余提款次数',
    VIP每日提款次数: 'VIP每日提款次数',
    单笔最小提款: '单笔最小提款',
    单笔最大提款: '单笔最大提款',
    USDT地址: 'USDT 地址',
    今天提款次数已用完: '今天提款次数已用完',
    提现提示: '提现提示',
    系统异常: '系统异常',
    '你好，我们有一份礼物送给你': '你好，我们有一份礼物送给你',
    请输入礼品代码: '请输入礼品代码',
    奖金金额: '奖金金额: {value}',
    关注官方渠道获取代码: '关注官方渠道获取代码',
    '该金额暂无可用的充值通道,请更换充值金额': '该金额暂无可用的充值通道,请更换充值金额',
    联系客服: '联系客服',
    上月: '上月',
    礼物: '礼物',
    公链查询: '公链查询',
    区块: '区块',
    区块时间: '区块时间',
    哈希: '哈希',
    trx详情:
        '什么是哈希值？<br/><br/>了解比特币基础知识的人都会接触到一个概念，哈希值。比特币的区块头里面有前一个区块的哈希值，用来指向前一个区块。<br/><br/>Hash是英文hash的音译，我们也可以译成哈希，所以哈希值又叫散列值。哈希值是用哈希函数（或哈希函数/哈希算法）计算出来的值。要理解哈希值，必须了解哈希函数的本质，哈希函数可以将任意长度的输入通过计算转换成固定长度的输出。<br/><br/>每个哈希函数都具有这样的性质，如果输入值相同，则输出的哈希值相同。如果输入值不同，则输出的哈希通常不同，但有极小的几率发生哈希碰撞。如果只需稍微改变输入值就可以排除哈希碰撞，则会输出完全不相关的哈希值。由于哈希函数不可逆，易于验证，通过输出哈希值几乎不可能反推输入值，如果有输入值，立刻就可以验证对应的哈希值。<br/><br/>因此每个区块的哈希值都是唯一、随机的，不可破解、不可伪造，区块哈希值自动识别，记录不可篡改。<br/><br/>USDT有几种类型？<br/><br/>1、基于比特币网络的Omni-USDT，充值地址为BTC地址，充提走BTC网络；<br/><br/>2、基于以太坊ERC20协议的ERC20-USDT，充值地址为ETH地址，充提走ETH网络；<br/><br/>3、基于TRON TRC20协议和TRX（波场）网络的TRC20-USDT，充值地址为波场地址，充提走波场网络。<br/><br/>TrxHash是基于TRON TRC20协议和TRX（波场）网络的TRC20-USDT区块哈希，最后一个数字作为开奖结果判定是否中奖（点击Block Height可以去公链查询唯一区块哈希）<br/><br/>玩法规则如下：<br/><br/>1、1分钟开奖1次，45秒内购买，开奖前15秒内无法购买。<br/><br/>2、购买全天解锁，一天总购买数量为1440次。<br/><br/>3、 3分1次、5分1次、10分1次，规则和1分1次一样只是开奖时间不一样。<br/><br/>4、以区块哈希值最后一位作为开奖结果：<br/><br/>例：<br/><br/>哈希值为**b569，则开奖结果为9<br/><br/>哈希值为**d14c，则开奖结果为4<br/><br/>您花费100进行交易，扣除2%手续费后，合约金额为：98<br/><br/>l 选择绿色：结果显示1,3,7,9，则可获得（98*2）=196；结果显示5，则可获得（98*2）=196<br/><br/>l 选择红色：结果显示2,4,6,8，则可获得（98*2）=196；如果结果显示0，您将获得（98 * 2）= 196<br/><br/>l 选择紫色：如果结果显示0或5，您将获得（98 * 2）= 196<br/><br/>l 选择数字：如果开奖结果与您选择的数字相同，您将获得（98 * 9）= 882<br/><br/>l 选择大：如果结果显示5,6,7,8,9，您将获得（98 * 2）= 196<br/><br/>l 选择小：如果结果显示0,1,2,3,4，您将获得（98 * 2）= 196',
    'WIN TRX彩票': 'WIN TRX彩票',
    确认进入游戏吗: '确认进入游戏吗?',
    奖励兑换码: '奖励兑换码',
    注册时间: '注册时间',
    '7 天全额存款': '<span>{value}</span> 天全额存款',
    何时可以领取奖金: '何时可以领取奖金',
    神秘奖金: '神秘奖金',
    活动已过期: '活动已过期',
    已领取: '已领取',
    首次存款: '首次存款',
    活动说明: '活动说明',
    等级优惠: '等级优惠',
    当前等级: '当前等级',
    铁: '铁',
    青铜: '青铜',
    白银: '白银',
    黄金: '黄金',
    铂金: '铂金',
    钻石: '钻石',
    近7天游戏营业额: '近{value}天游戏营业额',
    未达成: '未达成',
    已申请: '已申请',
    已收到: '已收到',
    保存: '保存',
    每周奖金: '每周奖金',
    领取时间: '领取时间',
    加载更多: '加载更多',
    游戏大厅: '游戏大厅',
    更多游戏: '更多游戏',
    底部描述:
        '{value} 由 {value2} 公司运营，公司注册号为 142922，注册地址为 Zuikertuintjeweg Z/N (Zuikertuin Tower) 库拉索，由库拉索政府许可和授权。{value} 在游戏服务提供商 N.V. 主许可证下运营。许可证号:GLH-OCCHKTW065752688',
    底部描述2: ' <p>1. 本产品仅供 18 岁或以上的用户使用，仅用于娱乐目的。</p><p>2. 本游戏包含应用内购买。</p><p>3. 玩家玩社交赌博游戏或获胜并不意味着他或她将来会在真钱赌博和相关游戏中获胜。</p>',
    版权声明: '{value} {value2}.保留所有权利。18+',
    支付成功: '支付成功',
    最大掉落: '每次 {value} 最大掉落',
    每天几次: '每天{value}次',
    当前输赢: '当前亏损',
    当前可领金额: '当前可领金额',
    上一期输赢: '上期亏损',
    上一期可领金额: '上一期可领金额',
    赎回基金表: '赎回基金表',
    比赛失败: '比赛失败',
    赎回费用: '赎回费用',
    救援金: '救援金',
    本周补偿: '本周补偿',
    本周盈利: '本周盈利',
    可获得补偿: '可获得补偿',
    本周的补偿将分配到: '本周的补偿将分配到',
    每周报酬: '每周报酬',
    补偿: '补偿',
    累计投注: '累计投注',
    通过累积投注提升VIP等级: '通过累积投注提升VIP等级',
    立即下载: '立即下载',
    下载应用程序: '下载应用程序',
    您要下载并安装APP吗: '您要下载并安装APP吗?',
    暂无可用手机号: '暂无可用手机号',
    '下载地址不存在，请稍后重试': '下载地址不存在，请稍后重试',
    '下载已开始，请在通知栏查看下载进度': '下载已开始，请在通知栏查看下载进度',
    '下载失败，请稍后重试': '下载失败，请稍后重试',
    支付倒计时: '请在 {value} 内完成支付',
    支付方式: '支付方式',
    钱包支付: '钱包支付',
    取消充值申请: '取消充值申请',
    查看充值记录: '查看充值记录',
    打开App: '打开{value}',
    每日游戏收入: '每日游戏收入',
    签到奖金: '签到奖金',
    手机号首位不能为0: '手机号首位不能为0',
    真实姓名只能包含英文字母和空格: '真实姓名只能包含英文字母和空格',
    请输入正确的银行卡账号: '请输入正确的银行卡账号',
    请输入15位仅包含数字和字母的账号: '请输入15位仅包含数字和字母的账号',
    请输入CLABE账号: '请输入CLABE账号',
    请输入正确的CLABE账号: '请输入正确的CLABE账号',
    利息: '利息',
    转入金额必须大于: '转入金额必须大于{value}',
    最小金额为: '最低{value},仅限整数',
    已转入: '已转入',
    年利率: '年利率{value}%',
    周期: `<span><span style="color: var(--profit-color-hover);">{value}</span>结算周期(最大<span style="color: var(--profit-color-hover);"> {value2}</span>)</span>`,
    待处理: `<span>待处理<span style="color: var(--profit-text-warning);"> {value} </span>(已完成{value2})</span>`,
    收取: '收取',
    累计收益: '累计收益<span style="color: var(--profit-text-warning);"> {value}</span>',
    交易类型: '交易类型',
    奖金: '奖金',
    详细资料: '详细资料',
    规则说明: '规则说明',
    解决周期: '结算周期',
    转账金额: '转账金额',
    当前时间: '当前时间',
    存款利息结算: '本次存款后，首次利息将在{value}出现',
    确认转账: '确认转账',
    当前储蓄本: '当前储蓄本',
    转出金额: '转出金额',
    本次循环的倒计时: '本次循环的倒计时',
    提取利息提示: '一旦提取，您将失去本次循环的利息！',
    确认提现: '确认提现',
    转入: '转入',
    账户余额: '账户余额',
    提款最小金额: '最小提款金额{value}',
    提取金额必须大于: '提取金额必须大于{value}',
    提取金额不能超过账户金额: '提取金额不能超过账户金额',
    转入成功: '转入成功',
    提取成功: '提取成功',
    提取失败: '提取失败',
    转入失败: '转入失败',
    无限: '无限',
    时: '{value}小时',
    分: '{value}分钟',
    秒: '{value}秒',
    利息宝未开启: '利息宝未开启',
    已完成: '已完成',
    处理中: '处理中',
    已取消: '已取消',
    已提交: '已提交',
    审核中: '审核中',
    已审核: '已审核',
    出款中: '出款中',
    出款失败: '出款失败',
    补单成功: '补单成功',
    补单失败: '补单失败',
    请输入UTR: '请输入UTR',
    请输入数字和字母: '请输入数字和字母',
    补单: '补单',
    请输入12位数字: '请输入12位数字',
    最多只能选择9个号码: '最多只能选择9个号码',
    请选择支付方式: '请选择支付方式',
    用户ID: '用户ID/手机号',
    总余额: '总余额',
    提现余额: '提现余额',
    请输入用户ID: '请输入用户ID/手机号',
    TelegramChannel: 'Telegram 频道',
    真实姓名的长度不小于5个字符: '真实姓名的长度不小于5个字符',
    下载: '下载',
    强度: '强度',
    余额不足: '余额不足',
    客服: '客服',
    有效投注总额:"有效投注总额",
    盈亏总额:"盈亏总额",
    注册账户: '注册账户',
    注册完成后可获得奖励: '完成注册后，您可以<span class="intro-highlight">获得{value}</span>奖励',
    
    // 第三方登录相关
    第三方登录: '第三方登录',
    登录方式: '登录方式',
    
    // 回调页面加载相关
    '正在处理登录...': '正在处理登录...',
    '请稍候，即将为您跳转': '请稍候，即将为您跳转',
    赠送中心: '赠送中心',
    截止日期: '截止日期',
    返回顶部: '返回顶部',
    游戏: '游戏',
    搜索游戏: '搜索游戏',

    // 投注相关
    下注成功: '下注成功',
    下注失败: '下注失败',
    游戏历史: '游戏历史',
    期数: '期数',
    存款宝箱: '存款宝箱',
    归回累存: '归回累存',
    统计截至: '统计截至',
    剩余天数: '剩余天数',
    当前累计: '当前累计',
    距: '距',
    还差: '还差',
    当前可领取: '当前可领取',
    档: '档',
    累计门槛: '累计门槛',
    赠送金额: '赠送金额',
    打码: '打码',
    可提前领取: '可提前领取，领取后不可再冲更高档',
    活动进行中: '活动进行中',
    活动到期领取: '活动进行中, 活动到期后可领取',
    第几天: '第{value}天',
    已于第几天领取: '已于第{value}天领取<strong>{value1}</strong>',
    几天: '{value}天',
    回归每日首存: '回归每日首存',
    今日时间: '今日时间',
    今日首笔存款: '今日首笔存款',
    可用奖金: '可用奖金',
    奖金比例: '奖金比例',
    立即领取: '立即领取',
    去充值: '去充值',
    查看活动: '查看活动',
    再充值一点更划算: '再充值一点更划算',
    当前档: '当前档',
    冲刺档: '冲刺档',
    冲: '冲',
    直接领取当前奖励: '直接领取当前 {value}',
    活动结束: '活动结束',
    恭喜领取成功: '恭喜领取成功',
    累计奖励已入账户: '累计奖励 {value} 已存入账户',
    请完成打码流水后提现: '请完成打码流水后提现',
    知道了: '知道了',
    去下注: '去下注',
    充值后最高赠送: '充值后最高赠送{value}',
    倍数: '倍数',
    必须通过此页面充值才能获得多倍奖金: '必须通过此页面充值才能获得多倍奖金',
    已领取宝箱金额: '已领取宝箱金额',
    已领取翻倍奖励: '已领取翻{value}倍奖励',
    充值领取最高: '充值领取最高：{multiple}倍，{value}奖励',
    说明: '说明',
    翻倍充值说明: '翻倍充值说明',
    参与活动: '参与活动',
    领取额外奖励: '领取额外奖励',
    开始时间: '开始时间',
    流水倍数: '流水倍数',
    打开: '打开',
    继续领取: '继续领取',
    翻倍领取: '翻倍领取',
};
